import React from "react";
import { Link, useNavigate } from "react-router-dom";
import Icons from "../components/icons";
import "../styles/header.css";
import "bootstrap/dist/css/bootstrap.min.css";

function Header({ toggleSidebar, isSidebarOpen }) {
  const navigate = useNavigate();

  //       headers: { Authorization: `Bearer ${localStorage.getItem("adminToken")}` },
  //     });
  //     setNotificationsCount(response.data.count || 0);
  //   } catch (error) {
  //     console.error("Error fetching unread notifications:", error);
  //   }
  // };
  // useEffect(() => {
  //   fetchUnreadNotifications();
  // }, []);

  // const handleNotificationClick = () => {
  //   navigate("/admin/notification");
  //   setNotificationsCount(0);
  // };

  // Logout Function
  const handleLogout = async () => {
    try {
      localStorage.removeItem("adminToken");
      localStorage.removeItem("remember_token");

      document.cookie = "admin_token=; Max-Age=0; path=/; domain=" + window.location.hostname;
      document.cookie = "remember_token=; Max-Age=0; path=/; domain=" + window.location.hostname;

      navigate("/admin/login", { replace: true });

      setTimeout(() => {
        window.history.replaceState(null, "", "/admin/login");
      }, 100);

    } catch (error) {
      console.error("Error during logout:", error);
    }
  };

  return (
    <nav className={`main-header navbar navbar-expand navbar-white navbar-light ${isSidebarOpen ? "overlay" : ""}`}>
      <div className="menu-icon-bx" onClick={toggleSidebar}>
        <span></span>
        <span></span>
        <span></span>
      </div>
      <Link to="#" className="mh-brand-link">
        <img className="mh-main-logo" src="/img/logo/logo2.png" alt="Main Logo" />
        <img className="mh-logo-icon" src="/img/logo/icon.png" alt="Icon Logo" />
      </Link>
      <ul className="navbar-nav ml-auto">
        <li className="nav-item item-nav">
          {/* temporarily disabled */}
          {/* <Link className="nav-link nav-notification" to="/admin/notification" onClick={handleNotificationClick}>
            <Icons.BellIcon />
            {notificationsCount > 0 && (
              <span id="notification-badge" className="nav-num">{notificationsCount}</span>
            )}
          </Link> */}
        </li>
        <li className="nav-item item-nav">
          <button type="button" className="nav-link nav-logout" onClick={handleLogout}>
            <Icons.LogoutIcon />
            <div className="nav-label">Logout</div>
          </button>
        </li>
      </ul>
    </nav>
  );
}

export default Header;
